import type { MapDispatchToPropsFunction } from 'types/redux';
import * as coreBi from '#packages/coreBi';
import { dispatchEditorAPI } from '../../topBarComponent/topBarMapper';
import type { HelpChatbotEntryOwnProps } from './helpChatbotEntry';

export interface HelpChatbotEntryDispatchProps {
  sendBiOnChatbotClick: () => void;
}

const mapDispatchToProps: MapDispatchToPropsFunction<
  HelpChatbotEntryDispatchProps,
  HelpChatbotEntryOwnProps
> = (dispatch) => ({
  sendBiOnChatbotClick: dispatchEditorAPI(dispatch, (editorAPI) => {
    editorAPI.bi.event(coreBi.events.topbar.top_bar_HELP_menu_click, {
      category: 'chatbot',
    });
  }),
});

export { mapDispatchToProps };
